// extracted by mini-css-extract-plugin
export default {"item":"_4ed38554","favorites":"_8f030a66","favoritesWrapper":"_504175d5","favoritesIconWrapper":"_54a5dcbe"};